import { privateRequest, type ApiResponse } from "../axios";

const ENDPOINTS = {
  TEAM_GC_DETAIL: "api/CRM/MyTeamWithGCDetail",
  MY_TEAM: "api/CRM/GetMyTeam",
  CALL_LOGS_BY_USERID: "api/CRM/CallLogsByUserId",
  TIMELINE: "api/CRM/TimeLine",
  USER_ACTIVITY_DASHBOARD: "api/CRM/UserActivityDashboard",
  USER_REPORT: "api/UserReport",
  MEETINGS: "api/CRM/LeadRoster",
  ATTENDANCE_REPORT: "api/GC/DailyAttendanceReport",
  LOGS: "api/AppLogs",
  TEAM_WISE_GLOBAL_MAP_DATA: "api/CRM/MyTeamDateWiseGlobalMapDataForWeb",
  USER_WISE_GLOBAL_MAP_DATA: "api/UserDateWiseGlobalMapData",
  USER_LOCATION: "api/User/Location",
  ATTENDANCE_REGULARIZATION: "api/AttendanceRegularization",
  REGULARIZATION_HISTORY: "api/RegularisationHistory",
  GEO_USER_DETAIL: "api/GeoUserDetail",
  GEO_FENCING_AREA: "api/GetGeoFencingArea",
  USER_GLOBAL_SETTING: "api/GetUserGlobalSetting",
  UPDATE_GLOBAL_SETTING: "api/GC/GlobalSetting",
  ADD_GEO_FENCING: "api/AddGeoFencing",
  UPDATE_GEO_FENCING: "api/UpdateGeoFencing",
  REMOVE_GEO_FENCING: "api/RemoveGeoFencing",
  GEO_FENCE_TYPE: "api/GeoFenceTypes",
  ADD_HOLIDAY: "api/AddFestival",
  DELETE_HOLIDAY: "api/DeleteFestival",
  WORKSTATION: "api/WorkStation",
  CHECK_IN_CLAIMS: "api/CheckInClaims",
  UPDATE_CHECKINTIME: "api/RequestToUpdateCheckInTime",
  UPDATE_REQUEST_CHECKINTIME: "api/UpdateStatusOfRequestCheckInTime",
  USER_NOT_PUNCHEDIN_REPORT: "api/GC/UsersNotPunchedInReport/Export",
  DOWNLOAD_ATTENDANCE_REPORT: "api/GC/DownloadAttendanceReport",
  MANAGER: "api/Users/GetManagers",
  INACTIVE_USER: "api/Users/GetDeactivatedUsers",
  ALL_USERS_GLOBAL_MAP_DATA: "api/AllUsersDateWiseGlobalMapData",
  SEND_USER_REPORT: "api/SendUserReport",
  SEND_ALL_USERS_REPORT: "api/SendAllUsersReport",
  SEND_ALL_USERS_DETAIL_REPORT: "api/SendAllUsersDetailReport",
  USER_SETTING: "api/GetUserSetting",
  UPDATE_USER_SETTING: "api/AddOrUpdateUserSetting",
  ADMIN_USERS: "api/AdminUsers",
  REMOVE_ADMIN_USERS: "api/RemoveAdminUsers",
  UPDATE_NOTIFY_ADMIN: "api/AddOrUpdateNotifyAdminForUser",
  USER_PUNCHIN: "api/CheckIn",
  USER_PUNCHOUT: "api/CheckOut",
  ALL_USERS_SETTING_LIST: "api/GetAllUserSettingsList",
  EXPORT_USER_SETTING_LIST: "api/GetAllUserSettingsListExport",
  GET_IMAGE: "api/CRM/LeadTransactionImages",
  LATE_CHECKIN: "api/LateCheckIn",
  UPDATE_LATE_CHECKIN: "api/LateCheckIn/Approve",
  ATTACHMENT_CHECK_IN_REQUEST: "api/checkInRequest/attachment",
  USER_CHECK_IN_CLAIM: "api/UserCheckInClaims",
  DEVICE_CHANGE_LOGS: "api/ChangeDeviceLogs",
  DEVICE_CHANGE_LOGS_EXPORT: "api/ChangedDeviceLogs/Export",
  DAILY_STATUS_REPORT: "api/Users/DailyStatusReport",
  TEAM_CLAIMS_LOGS : "api/Timesheet/1234/History"
};

const getMyTeamGCDetail = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(
    ENDPOINTS.TEAM_GC_DETAIL,
    data
  );
  return res.data;
};

const getMyTeam = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(
    `${ENDPOINTS.MY_TEAM}?userId=${data.userId}&isActive=${data.isActive}`
  );
  return res.data;
};

const getCallLogsByUserId = async (data: any): Promise<ApiResponse<any[]>> => {
  const res = await privateRequest.get<ApiResponse<any[]>>(
    `${ENDPOINTS.CALL_LOGS_BY_USERID}?userId=${data.userId}&fromDate=${data.fromDate}&toDate=${data.toDate}`
  );
  return res.data;
};

const getTimeline = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(
    ENDPOINTS.TIMELINE,
    data
  );
  return res.data;
};

const getUserActivityDashboard = async (
  userId: number
): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(
    `${ENDPOINTS.USER_ACTIVITY_DASHBOARD}?userId=${userId}`
  );
  return res.data;
};

const getUserReport = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(
    ENDPOINTS.USER_REPORT,
    data
  );
  return res.data;
};

const getMeetings = async (data: any): Promise<ApiResponse<any[]>> => {
  const res = await privateRequest.post<ApiResponse<any[]>>(
    ENDPOINTS.MEETINGS,
    data
  );
  return res.data;
};

const getUpcomingMeetings = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(
    ENDPOINTS.MEETINGS,
    data
  );
  return res.data;
};

const getDailyAttendanceReport = async (
  data: any
): Promise<ApiResponse<any[]>> => {
  const res = await privateRequest.post<ApiResponse<any[]>>(
    ENDPOINTS.ATTENDANCE_REPORT,
    data
  );
  return res.data;
};

const getLogs = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(
    `${ENDPOINTS.LOGS}?ForUserId=${data.ForUserId}&From=${data.From}&FromDate=${data.FromDate}&To=${data.To}&ToDate=${data.ToDate}`
  );
  return res.data;
};

const getTeamWiseGlobalMapData = async (
  date: string
): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(
    `${ENDPOINTS.TEAM_WISE_GLOBAL_MAP_DATA}?date=${date}`
  );
  return res.data;
};

const getUserWiseGlobalMapData = async (
  data: any
): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(
    `${ENDPOINTS.USER_WISE_GLOBAL_MAP_DATA}?userId=${data.userId}&date=${data.date}`
  );
  return res.data;
};

const getUserLocation = async (data: any): Promise<ApiResponse<any[]>> => {
  const res = await privateRequest.get<ApiResponse<any[]>>(
    `${ENDPOINTS.USER_LOCATION}?userId=${data.userId}&fromDate=${data.fromDate}&toDate=${data.toDate}`
  );
  return res.data;
};

const updateAttendanceRegularization = async (
  data: any
): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post(
    ENDPOINTS.ATTENDANCE_REGULARIZATION,
    data
  );
  return res.data;
};

const getRegularizationHistory = async (
  CheckInId: number
): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get(
    `${ENDPOINTS.REGULARIZATION_HISTORY}?CheckinId=${CheckInId}`
  );
  return res.data;
};

const getGeoUserDetail = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(
    ENDPOINTS.GEO_USER_DETAIL,
    data
  );
  return res.data;
};

const getGeoFencingArea = async (): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(
    ENDPOINTS.GEO_FENCING_AREA
  );
  return res.data;
};

const addGeoFencing = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(
    ENDPOINTS.ADD_GEO_FENCING,
    data
  );
  return res.data;
};

const updateGeoFencing = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(
    ENDPOINTS.UPDATE_GEO_FENCING,
    data
  );
  return res.data;
};

const removeGeoFencing = async (Id: number): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(
    `${ENDPOINTS.REMOVE_GEO_FENCING}?Id=${Id}`
  );
  return res.data;
};

const getGeoFenceType = async (): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(
    ENDPOINTS.GEO_FENCE_TYPE
  );
  return res.data;
};

const getUserGlobalSetting = async (): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(
    ENDPOINTS.USER_GLOBAL_SETTING
  );
  return res.data;
};

const updateGlobalSetting = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.put<ApiResponse<any>>(
    ENDPOINTS.UPDATE_GLOBAL_SETTING,
    data
  );
  return res.data;
};

const addHoliday = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(
    ENDPOINTS.ADD_HOLIDAY,
    data
  );
  return res.data;
};

const deleteHoliday = async (holidayId: number): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(
    `${ENDPOINTS.DELETE_HOLIDAY}?HolidayId=${holidayId}`
  );
  return res.data;
};

const getWorkstation = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(
    `${ENDPOINTS.WORKSTATION}?From=${data.From}&To=${data.To}&Search=${data.Search}&IsActive=${data.IsActive}`
  );
  return res.data;
};

const addWorkstation = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(
    ENDPOINTS.WORKSTATION,
    data
  );
  return res.data;
};

const updateWorkstation = async (
  id: number,
  data: any
): Promise<ApiResponse<any>> => {
  const res = await privateRequest.put<ApiResponse<any>>(
    ENDPOINTS.WORKSTATION + id,
    data
  );
  return res.data;
};

const deleteWorkstation = async (id: number): Promise<ApiResponse<any>> => {
  const res = await privateRequest.delete<ApiResponse<any>>(
    ENDPOINTS.WORKSTATION + id
  );
  return res.data;
};

const getCheckInClaims = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(
    ENDPOINTS.CHECK_IN_CLAIMS,
    data
  );
  return res.data;
};

const updateCheckInTime = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(
    ENDPOINTS.UPDATE_CHECKINTIME,
    data
  );
  return res.data;
};

const updateStatusOfRequestCheckInTime = async (
  data: any
): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(
    ENDPOINTS.UPDATE_REQUEST_CHECKINTIME,
    data
  );
  return res.data;
};

const exportUserNotPunchedInReport = async () => {
  const res = await privateRequest.get<ApiResponse<any>>(
    ENDPOINTS.USER_NOT_PUNCHEDIN_REPORT,
    { responseType: "arraybuffer" }
  );
  return res;
};

const exportAttendanceReport = async (data: any) => {
  const res = await privateRequest.post<ApiResponse<any>>(
    ENDPOINTS.DOWNLOAD_ATTENDANCE_REPORT,
    data,
    { responseType: "arraybuffer" }
  );
  return res;
};

const emailAttendanceReport = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(
    ENDPOINTS.DOWNLOAD_ATTENDANCE_REPORT,
    data
  );
  return res.data;
};

const getManagers = async (): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.MANAGER);
  return res.data;
};

const getInactiveUsers = async (): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(
    ENDPOINTS.INACTIVE_USER
  );
  return res.data;
};

const getGlobalMapData = async (date: string): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(
    `${ENDPOINTS.ALL_USERS_GLOBAL_MAP_DATA}?date=${date}`
  );
  return res.data;
};

const sendUserReport = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(
    ENDPOINTS.SEND_USER_REPORT,
    data
  );
  return res.data;
};

const sendAllUsersReport = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(
    ENDPOINTS.SEND_ALL_USERS_REPORT,
    data
  );
  return res.data;
};

const sendAllUsersDetailsReport = async (
  data: any
): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(
    ENDPOINTS.SEND_ALL_USERS_DETAIL_REPORT,
    data
  );
  return res.data;
};

const getUserSetting = async (userId: number): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(
    `${ENDPOINTS.USER_SETTING}?userId=${userId}`
  );
  return res.data;
};

const updateUserSetting = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(
    ENDPOINTS.UPDATE_USER_SETTING,
    data
  );
  return res.data;
};

const getAdminUsers = async (userId: number): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(
    `${ENDPOINTS.ADMIN_USERS}?userId=${userId}`
  );
  return res.data;
};

const removeAdminUsers = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(
    `${ENDPOINTS.REMOVE_ADMIN_USERS}?userId=${data.userId}&isExternal=${data.isExternal}`
  );
  return res.data;
};

const updateNotifyAdmin = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(
    ENDPOINTS.UPDATE_NOTIFY_ADMIN,
    data
  );
  return res.data;
};

const userPunchIn = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(
    ENDPOINTS.USER_PUNCHIN,
    data
  );
  return res.data;
};

const userPunchOut = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(
    ENDPOINTS.USER_PUNCHOUT,
    data
  );
  return res.data;
};

const getAllUserSettingsList = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.ALL_USERS_SETTING_LIST, { params: data });
  return res.data;
};

const getDailyStatusReport = async (data: any) => {
  const res = await privateRequest.get(ENDPOINTS.DAILY_STATUS_REPORT, { params: data , responseType  :"arraybuffer" });
  return res.data;
};

const exportUserSettingList = async (data: any) => {
  const res = await privateRequest.post<ApiResponse<any>>(
    ENDPOINTS.EXPORT_USER_SETTING_LIST,
    data,
    { responseType: "arraybuffer" }
  );
  return res;
};

const getLeadImage = async (id: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(
    `${ENDPOINTS.GET_IMAGE}?Id=${id}`
  );
  return res.data;
};

const lateCheckIn = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(
    `${ENDPOINTS.LATE_CHECKIN}?from=${data.from}&to=${data.to}&fromDate=${data.fromDate}&toDate=${data.toDate}&status=${data.status}&search=${data.search}`
  );
  return res.data;
};

const updateLateCheckInStatus = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(
    `${ENDPOINTS.UPDATE_LATE_CHECKIN}?checkInId=${data.checkInId}&isApproved=${data.isApproved}&reason=${data.reason}`,
  );
  return res.data;
};


const attachFileInClaims = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(
    `${ENDPOINTS.ATTACHMENT_CHECK_IN_REQUEST}?requestId=${data.requestId}`,
    data.formData
  );
  return res.data;
};

const userCheckInClaims = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(
    ENDPOINTS.USER_CHECK_IN_CLAIM, {params: data}
  );
  return res.data;
}

const getDeviceChangeLogs = async (data: any): Promise<ApiResponse<any>> => {
  const res = await privateRequest.post<ApiResponse<any>>(
    ENDPOINTS.DEVICE_CHANGE_LOGS,
    data
  );
  return res.data;
};

const getDeviceChangeLogsExport = async (data: any) => {
  const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.DEVICE_CHANGE_LOGS_EXPORT, data, { responseType: "arraybuffer" });
  return res;
}

const getTeamsClaimsLogs = async(id : any) => {
  const res = await privateRequest.get<any>(`api/Timesheet/${id}/History`);
  return res.data.data;
}

const TeamService = {
  getMyTeamGCDetail,
  getMyTeam,
  getCallLogsByUserId,
  getTimeline,
  getUserActivityDashboard,
  getUserReport,
  getMeetings,
  getUpcomingMeetings,
  getDailyAttendanceReport,
  getLogs,
  getTeamWiseGlobalMapData,
  getUserWiseGlobalMapData,
  getUserLocation,
  updateAttendanceRegularization,
  getRegularizationHistory,
  getGeoUserDetail,
  getGeoFencingArea,
  getUserGlobalSetting,
  updateGlobalSetting,
  addGeoFencing,
  updateGeoFencing,
  removeGeoFencing,
  getGeoFenceType,
  addHoliday,
  deleteHoliday,
  getWorkstation,
  addWorkstation,
  updateWorkstation,
  deleteWorkstation,
  getCheckInClaims,
  updateCheckInTime,
  updateStatusOfRequestCheckInTime,
  exportUserNotPunchedInReport,
  exportAttendanceReport,
  emailAttendanceReport,
  getManagers,
  getInactiveUsers,
  getGlobalMapData,
  sendUserReport,
  sendAllUsersReport,
  sendAllUsersDetailsReport,
  getUserSetting,
  updateUserSetting,
  getAdminUsers,
  removeAdminUsers,
  updateNotifyAdmin,
  userPunchIn,
  userPunchOut,
  getAllUserSettingsList,
  exportUserSettingList,
  getLeadImage,
  lateCheckIn,
  updateLateCheckInStatus,
  attachFileInClaims,
  userCheckInClaims,
  getDeviceChangeLogs,
  getDeviceChangeLogsExport,
  getDailyStatusReport,
  getTeamsClaimsLogs
};

export default TeamService;
